// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JT7fh","top":"styles_top__2s3YM"};